import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 400,
  },
}))

const DeleteIcon = ({ onClick }) => {
  const classes = useStyles()
  return (
    <FontAwesomeIcon onClick={onClick} className={classes.root} size="md" solid>
      trash
    </FontAwesomeIcon>
  )
}

export default DeleteIcon
